import axios from '../../config/axios';
// import { request as HTTP_REQUEST } from '../../constants/types';
export const requestAxios = async (type, path, body, config = {}) => {
    try {
        return await axios({
            method: type,
            url: path,
            data: JSON.stringify(body),
            ...config,
        })
    } catch (error) {
        throw error;
    }
}